import {
  CollapseIcon,
  FoldersClosedIcon,
  FoldersOpenedIcon,
  FullScreenIcon,
  MinusIcon,
  PlusIcon,
} from '../../../assets/icons';

export enum ButtonActionType {
  ZOOM_IN = 'zoom-in',
  ZOOM_OUT = 'zoom-out',
  EXPAND = 'fullscreen',
  COLLAPSE = 'colapse',
  NODES_EXPAND = 'nodes-expand',
  NODES_COLLAPSE = 'nodes-collapse',
}

export enum MindBranchEmun {
  PARENT = '0',
  FIRST = '1',
  SECOND = '2',
  THIRD = '3',
  FOURTH = '4',
  FIFTH = '5',
  SIXTH = '6',
}

export enum MinMapColorMode {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum MindNodeEmun {
  PARENT = 'parent',
  CHILD = 'child',
  SUBCHILD = 'subchild',
  SUBSUBCHILD = 'subsubchild',
}

export const ZoomButtons = [
  {
    icon: <PlusIcon />,
    action: ButtonActionType.ZOOM_IN,
  },
  {
    icon: <MinusIcon />,
    action: ButtonActionType.ZOOM_OUT,
  },
];

export const ScreenModeButtons = [
  {
    icon: <CollapseIcon />,
    action: ButtonActionType.COLLAPSE,
    state: true,
  },
  {
    icon: <FullScreenIcon />,
    action: ButtonActionType.EXPAND,
    state: false,
  },
];

export const NodesModeButtons = [
  {
    icon: <FoldersClosedIcon />,
    action: ButtonActionType.NODES_EXPAND,
    state: false,
  },
  {
    icon: <FoldersOpenedIcon />,
    action: ButtonActionType.NODES_COLLAPSE,
    state: true,
  },
];
